// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  firebaseConfig: {
    apiKey: 'AIzaSyBFMmVaO1nUneaEO9hfq_K8oFTCTj0EeUs',
    authDomain: 'ky-test-94459.firebaseapp.com',
    projectId: 'ky-test-94459',
    storageBucket: 'ky-test-94459.appspot.com',
    messagingSenderId: '316678011672',
    appId: '1:316678011672:web:1045b9f859cdb7ad087c6d',
  },
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
